import React, { useEffect, useRef, useState } from "react";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import axiosInstance from "../../../../services/api/API";
import Loader from "../../../../customComponents/CustomLoader";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import { showAlert } from "../../../../customComponents/CustomSweetAlert/ShowAlert";
import * as base64 from "base-64";
import CustomTable from "../../../../customComponents/CustomTable";

const EditPurchaseOrder = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [modelOptions, setModelOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [paymentTypeVal, setPaymnentTypeVal] = useState([]);
  const [financerVal, setFinancerVal] = useState([]);
  const [paymentModeVal, setPaymentModeVal] = useState([]);

    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [ paymentDetailsTable, setPaymentDetailsTable ] = useState([])
    const [ fetchedPaymentDataVal, setFetchedPaymentDataVal ] = useState([])
    const [ customerIdVal, setCustomerIdVal ] = useState()

  const [paymentSections, setPaymentSections] = useState([]);

  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const [roledd, setRoledd] = useState([]);
  const [vinOptions, setVinOptions] = useState([]);
  const [totalAmtValue, setTotalAmtValue] = useState();

  const location = useLocation();
  const dataValues = location?.state?.data;
  console.log(dataValues, "dataValues")
   const  text = dataValues?.postockinsr_id;
    const encoded = base64.encode(text);

  const [customerId, setCustomerId] = useState();

  const initialBasePriceRef = useRef(null);

  useEffect(() => {
    if (
      formData.baseprice !== undefined &&
      formData.baseprice !== null &&
      initialBasePriceRef.current === null
    ) {
      initialBasePriceRef.current = formData.baseprice;
      console.log("Initial base price set to:", formData.baseprice);
    }
  }, [formData.baseprice]);

  const userType = localStorage.getItem("UserType");
  console.log(userType, "USERTYPE");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const dealer_id = localStorage.getItem("dealerId");

  useEffect(() => {
    fetchCustomerPurchaseOrderDetails()
  },[])

  const fetchCustomerPurchaseOrderDetails =async () => {
    try{
        const response = await axiosInstance.get(`/customer-po/customer-po-detail/${encoded}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });
    
          const fetchedData = response?.data?.data; 
          const fetchedPaymentData = response?.data?.data?.payment_details;
          const customerId = response?.data?.data?.customer_id
          console.log(customerId, "customerId")
          setCustomerIdVal(customerId)
          setFetchedPaymentDataVal(fetchedPaymentData)
          console.log(fetchedPaymentData, "fetchedPaymentData")

          setFormData((prevData) => ({
            ...prevData,
            full_name: fetchedData?.cusName,
            mobile_no:fetchedData?.cusMobile,
            email_id:fetchedData?.cusEmail,
            address:fetchedData?.cusAddress,
            pincode:fetchedData?.cusPincode,
            variant:fetchedData?.variant_name,
            vin_no:fetchedData?.vin_no,
            baseprice:fetchedData?.baseprice,
            tax_percent:fetchedData?.tax_percent,
            model:fetchedData?.model_name,
            color_id:fetchedData?.color_name,
            customer_delivery_date:fetchedData?.customer_delivery_date,
          }));

    }catch(error){
        console.log(error, "error")
    }
  }

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    roleDropdown();
  }, []);

  const roleDropdown = async () => {
    try {
      const payload = {
        business_partner_id:
          userType === "superadmin"
            ? formData?.business_partner_id
            : businessPartnerId,
      };

      const response = await axiosInstance.post("/role/ddlrole", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const roleOptions = data.map((role) => ({
        value: role.ID,
        label: role.NAME,
      }));
      setRoledd(roleOptions);
    } catch (error) {
      console.log(error);
    }
  };

  // const handleFormSubmit = async (formData) => {
  //   console.log("dealerformdata",formData);

  //   const errors = {};
  //   let isValid = true;

  //   DealerInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       } else if (
  //         field.validation.pattern &&
  //         !field.validation.pattern.test(formData[field.name])
  //       ) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you want to add this record?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {

  //         // Map postockinsr_id back to vin_no
  //       const selectedVinOption = vinOptions.find(
  //         (option) => option.value === formData.vin_no
  //       );

  //         setLoading(true);
  //         const payload = {
  //           full_name: formData.full_name,
  //           email_id: formData.email_id,
  //           mobile_no: formData.mobile_no,
  //           address: formData.address,
  //           email_id: formData.email_id,
  //           customer_delivery_date: formData.customer_delivery_date,
  //           // vin_no: formData.vin_no,
  //           vin_no: selectedVinOption?.label,
  //           country_id: formData.country_id,
  //           state_id: formData.state_id,
  //           city_id: formData.city_id,
  //           pincode: formData.pincode,
  //           dealer_id:dealer_id,
  //           discount:"0",
  //           discount_type:"0",
  //           // color_id:formData.color_id,
  //           // total_price:formData.totalamount,
  //           total_price: formData.totalamount,
  //           total_cus_basic_price:formData.baseprice.toString(),
  //           cust_tax: formData.tax_percent,
  //           cust_tax_amnt:formData.taxamount.toString(),
  //           remark:formData.remark
  //         };

  //         // API call to create a dealer
  //         const response = await axiosInstance.post('/customer-po/create', payload, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${authToken}`,
  //           },
  //         });

  //         if (response.status === 200) {
  //           navigate("/sales/manage-customer-purchase-order/purchase-order")
  //           setFormData({})
  //         }

  //       } catch (error) {

  //         console.error('Error adding record:', error);
  //         const errorMessage = error.response?.data?.message;
  //         console.log(errorMessage, "errorMessage")
  //         Swal.fire({
  //           title: "Error",
  //           text: errorMessage,
  //           icon: "error",
  //           confirmButtonText: "OK",
  //         });
  //       } finally {

  //         setLoading(false);
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {

  //       Swal.fire({
  //         title: "Cancelled",
  //         text: "The record was not added.",
  //         icon: "info",
  //         confirmButtonText: "OK",
  //       });

  //       setLoading(false);
  //     }
  //   });
  // };

  const handleFormSubmit = async (formData) => {
    console.log("dealerformdata", formData);

    const errors = {};
    let isValid = true;

    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    // Show baseprice change alert if modified
    if (
      initialBasePriceRef.current !== null &&
      formData.baseprice !== initialBasePriceRef.current
    ) {
      await Swal.fire({
        title: "Price Confirmation",
        text: `Base price has been changed from ${initialBasePriceRef.current} to ${formData.baseprice}`,
        icon: "info",
        confirmButtonText: "OK",
      });
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const selectedVinOption = vinOptions.find(
            (option) => option.value === formData.vin_no
          );

          setLoading(true);
          const formPayload = new FormData();
          formPayload.append("full_name", formData.full_name);
          formPayload.append("email_id", formData.email_id);
          formPayload.append("mobile_no", formData.mobile_no);
          formPayload.append("address", formData.address);
          formPayload.append(
            "customer_delivery_date",
            formData.customer_delivery_date
          );
          formPayload.append("vin_no", selectedVinOption?.label || "");
          formPayload.append("country_id", formData.country_id);
          formPayload.append("state_id", formData.state_id);
          formPayload.append("city_id", formData.city_id);
          formPayload.append("pincode", formData.pincode);
          formPayload.append("dealer_id", dealer_id);
          formPayload.append("discount", "0");
          formPayload.append("discount_type", "0");
          formPayload.append("total_price", formData.totalamount);
          formPayload.append(
            "total_cus_basic_price",
            formData.baseprice.toString()
          );
          formPayload.append("cust_tax", formData.tax_percent);
          formPayload.append("cust_tax_amnt", formData.taxamount.toString());
          formPayload.append("remark", formData.remark);
          // formPayload.append("payment_type", formData.payment_type);
          // formPayload.append("down_payment", formData.downPayment);
          // formPayload.append("finance_bank", formData.finance_bank);
          // formPayload.append("no_of_month", formData.no_of_month);
          // formPayload.append("payment_mode", formData.payment_mode);

        //   formPayload.append(
        //     "po_finance_details[0][payment_type]",
        //     formData.payment_type !== undefined ? formData.payment_type : 0
        //   );
        //   formPayload.append(
        //     "po_finance_details[0][down_payment]",
        //     formData.downPayment !== undefined ? formData.downPayment : 0
        //   );
        //   formPayload.append(
        //     "po_finance_details[0][finance_bank]",
        //     formData.finance_bank !== undefined ? formData.finance_bank : 0
        //   );
        //   formPayload.append(
        //     "po_finance_details[0][no_of_month]",
        //     formData.no_of_month !== undefined ? formData.no_of_month : 0
        //   );
        //   formPayload.append(
        //     "po_finance_details[0][payment_mode]",
        //     formData.payment_mode !== undefined ? formData.payment_mode : 0
        //   );

        paymentSections.forEach((sectionConfig, index) => {
            const getFieldVal = (baseName) =>
              formData[`${baseName}_${index}`] !== undefined
                ? formData[`${baseName}_${index}`]
                : 0;
          
            formPayload.append(`po_finance_details[${index}][payment_type]`, getFieldVal("payment_type"));
            formPayload.append(`po_finance_details[${index}][down_payment]`, getFieldVal("downPayment"));
            formPayload.append(`po_finance_details[${index}][finance_bank]`, getFieldVal("finance_bank"));
            formPayload.append(`po_finance_details[${index}][no_of_month]`, getFieldVal("no_of_month"));
            formPayload.append(`po_finance_details[${index}][payment_mode]`, getFieldVal("payment_mode"));
          });

          // Append file if available
          if (formData.uploadFile) {
            formPayload.append("uploadFile", formData.uploadFile); // Make sure this matches your backend key
          }

          const response = await axiosInstance.post(
            "/customer-po/create",
            formPayload,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );

          const fetchedData = response?.data?.data;
          const customerIdVal = fetchedData?.postockinsr_id;
          // console.log(customerIdVal, "custidVal")
          // setCustomerId(customerIdVal)

          // if (response.status === 200) {
          //   navigate("/sales/manage-customer-purchase-order/purchase-order");
          //   handleMailFunc()
          //   setFormData({});
          // }

          if (response.status === 200) {
            navigate("/sales/manage-customer-purchase-order/purchase-order");
            handleMailFunc(customerIdVal); // pass ID directly here
            setFormData({});
          }
        } catch (error) {
          console.error("Error adding record:", error);
          const errorMessage = error.response?.data?.message;
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "The record was not added.",
          icon: "info",
          confirmButtonText: "OK",
        });

        setLoading(false);
      }
    });
  };

  const DealerInputs = [
    {
      name: "full_name",
      label: "Customer Name",
      placeholder: "Enter Customer Name",
      type: "text",
      required: true,
      disabled: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
        maxLength: 20,
      },
    },

    {
      name: "mobile_no",
      label: "Mobile No.",
      placeholder: "Enter Mobile No.",
      type: "text",
      required: true,
      disabled: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[6-9]/,
        minLength: 10,
        maxLength: 10,
        message1: "Contact No. should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit Contact No.",
      },
    },
    {
      name: "email_id",
      label: "Email ID",
      placeholder: "Enter Email Address",
      type: "text",
      disabled: true,
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: false,
        maxLength: 45,
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Please enter a valid Email Address",
      },
    },
    {
      name: "address",
      label: "Address",
      disabled: true,
      placeholder: "Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      disabled: true,
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, maxLength: 6 },
    },
    {
      name: "city",
      label: "City",
      placeholder: "City",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      placeholder: "State",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Country",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "model",
      label: "Model",
      type: "text",
      disabled: true,
    //   options: modelOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "color_id",
      label: "Color",
      placeholder: "Color",
      type: "text",
      disabled: true,
    //   options: colorOptions,
      // disabled:true,
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "variant",
      label: "Variant",
      placeholder: "",
      type: "text",
      disabled: true,
    //   options: variantOptions,
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "vin_no",
      label: "Vin No. / Serial No.",
      type: "text",
      disabled: true,
      placeholder: "Enter Vin/Serial No.",
    //   options: vinOptions,
      validation: {},

      gridClass: "col-lg-4",
    },
    {
      name: "baseprice",
      label: "Base Price",
      placeholder: "Enter Base Price",
      disabled: true,
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      //  disabled:true
    },
    {
      name: "tax_percent",
      label: "GST Percent",
      placeholder: "Enter Tax Percent",
      disabled: true,
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      disabled: true,
    },
    {
      name: "taxamount",
      label: "GST Amount",
      placeholder: "Enter Tax Percent",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      disabled: true,
    },
    // {
    //   name: "discount_type",
    //   label: "Discount Type",
    //   placeholder:"Enter ",
    //   type: "dropdown",
    //   options:[
    //       { value: "A", label: "Amount" },
    //       { value: "P", label: "Percentage" }
    //     ],
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true,
    //   },
    // },
    // {
    //   name: "discount",
    //   label: "Discount",
    //   placeholder:"Enter Discount",
    //   type: "text",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true,
    //    },
    // },
    {
      name: "customer_delivery_date",
      label: "Customer Delivery Date",
      type: "date",
      placeholder: "Enter GST No.",
      validation: { required: true },
      gridClass: "col-lg-4",
      minDate: new Date(),
      
    },
    {
      name: "totalamount",
      label: "Total Amount",
      placeholder: "Enter total amount",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      disabled: true,
    },
    // {
    //   name: "payment_type",
    //   label: "Payment Type",
    //   placeholder: "Enter ",
    //   type: "dropdown",
    //   options: paymentTypeVal,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    // {
    //   name: "downPayment",
    //   label: "Down Payment",
    //   placeholder: "Enter Down Payment",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    //   //  disabled:true
    // },
    // {
    //   name: "financeAmt",
    //   label: "Finance Amount",
    //   placeholder: "Enter Finance Amount",
    //   type: "number",
    //   // required: true,
    //   gridClass: "col-lg-4",
    //   // validation: { required: true,
    //   //  },
    //   disabled: true,
    // },
    // {
    //   name: "balanceAmt",
    //   label: "Balance Amount",
    //   placeholder:"Enter Balance Amount",
    //   type: "text",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true,
    //    },
    //   //  disabled:true
    // },
    // ...(
    // ),
    // ...(formData.payment_type !== 2
    //   ? [
    //       {
    //         name: "payment_mode",
    //         label: "Payment Mode",
    //         type: "dropdown",
    //         options: paymentModeVal,
    //         required: true,
    //         gridClass: "col-lg-4",
    //         validation: { required: true },
    //       },
    //       ...(formData.payment_type !== 3
    //         ? [
    //             {
    //               name: "no_of_month",
    //               label: "No. Of Months",
    //               placeholder: "Enter no. of months",
    //               type: "text",
    //               required: true,
    //               gridClass: "col-lg-4",
    //               validation: { required: true },
    //               //  disabled:true
    //             },
    //           ]
    //         : []),
    //       ...(formData.payment_mode !== 1
    //         ? [
    //             {
    //               name: "finance_bank",
    //               label: "Finance",
    //               placeholder: "Enter Finance",
    //               type: "dropdown",
    //               options: financerVal,
    //               required: true,
    //               gridClass: "col-lg-4",
    //               validation: { required: true },
    //               //  disabled:true
    //             },
    //           ]
    //         : []),
    //     ]
    //   : []),
    {
      name: "remark",
      label: "Remark",
      placeholder: "Enter Remark",
      type: "text",
      required: false,
      gridClass: "col-lg-4",
      // validation: { required: true},
      //  disabled:true
    },
    {
      name: "uploadFile",
      label: "Upload",
      type: "productfile",
      required: true,
      gridClass: "col-lg-6",
      validation: { required: true },
    },
  ];

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post("/model/ddlFmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    const modelId = formData.model;

    if (modelId) {
      fetchColorOptions(modelId);
    }
  }, [formData.model]);

  const fetchColorOptions = async (modelId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        model_id: modelId,
      };

      const response = await axiosInstance.post("/color/getcolor", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  const fetchPaymentModeVal = async () => {
    try {
      const payload = {};

      const response = await axiosInstance.post("/paymentmode/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.map((color) => ({
        label: color.payment_mode,
        value: color.payment_mode_id,
      }));

      setPaymentModeVal(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    fetchPaymentModeVal();
  }, []);

  const fetchFinancerVal = async () => {
    try {
      const payload = {};

      const response = await axiosInstance.post("/financer/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.financer_name,
        value: color.financer_id,
      }));

      setFinancerVal(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    fetchFinancerVal();
  }, []);

  const fetchPaymentTypeVal = async () => {
    try {
      const payload = {};

      const response = await axiosInstance.post("/paymenttype/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.map((color) => ({
        label: color.payment_type,
        value: color.id,
      }));

      setPaymnentTypeVal(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    fetchPaymentTypeVal();
  }, []);

  useEffect(() => {
    const colorId = formData.color_id;
    const modelId = formData.model;

    if (colorId && modelId) {
      fetchVariantOptions(colorId, modelId);
    }
  }, [formData.color_id, formData.model]);

  const fetchVariantOptions = async (colorId, modelId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/getvariant",
        {
          color_id: colorId,
          dealer_id: dealer_id,
          model_id: modelId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  useEffect(() => {
    const variantId = formData.variant;

    if (variantId) {
      fetchVinOptions(variantId);
    }
  }, [formData.variant]);

  const fetchVinOptions = async (variantId) => {
    try {
      const payload = {
        dealer_id: dealer_id,
        variant_id: variantId,
      };

      const response = await axiosInstance.post(
        "/sales/vin-num-list",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const options = response.data.data.data.map((model) => ({
        label: model.vin_no,
        value: model.postockinsr_id,
      }));

      setVinOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    const vinId = formData.vin_no;

    if (vinId) {
      fetchVinData(vinId);
    }
  }, [formData.vin_no]);

  const fetchVinData = async (vinId) => {
    try {
      const response = await axiosInstance.get(`/sales/vin-details/${vinId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const fetchedData = response?.data?.data[0];

      setFormData((prevData) => ({
        ...prevData,
        tax_percent: fetchedData.tax_percent,
        baseprice: fetchedData.baseprice,
        taxamount: fetchedData?.taxamount,
        totalamount: fetchedData?.totalamount,
      }));
      const totalAmtVal = fetchedData?.totalamount;
      setTotalAmtValue(totalAmtVal);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  // const handleMailFunc = async () => {
  //   const encoded = base64.encode(customerId);

  //   try {
  //     const response = await axiosInstance.get(
  //       `/purchaseorder/attchement-send-emailto-customer/${encoded}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       await showAlert({
  //         title: "Success",
  //         text: "Email sent successfully.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //     }

  //   } catch (error) {
  //     console.error("Error fetching action taken list:", error);
  //   }
  // };

  const handleMailFunc = async (id) => {
    const encoded = base64.encode(id.toString()); // Ensure it's a string

    try {
      const response = await axiosInstance.get(
        `/purchaseorder/attchement-send-emailto-customer/${encoded}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Email sent successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const basePaymentFields = [
    {
        name: "payment_type",
        label: "Payment Type",
        placeholder: "Enter ",
        type: "dropdown",
        options: paymentTypeVal,
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      {
        name: "downPayment",
        label: "Down Payment",
        placeholder: "Enter Down Payment",
        type: "number",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
        //  disabled:true
      },
      {
        name: "financeAmt",
        label: "Finance Amount",
        placeholder: "Enter Finance Amount",
        type: "number",
        // required: true,
        gridClass: "col-lg-4",
        // validation: { required: true,
        //  },
        disabled: true,
      },
      ...(formData.payment_type !== 2
        ? [
            {
              name: "payment_mode",
              label: "Payment Mode",
              type: "dropdown",
              options: paymentModeVal,
              required: true,
              gridClass: "col-lg-4",
              validation: { required: true },
            },
            ...(formData.payment_type !== 3
              ? [
                  {
                    name: "no_of_month",
                    label: "No. Of Months",
                    placeholder: "Enter no. of months",
                    type: "text",
                    required: true,
                    gridClass: "col-lg-4",
                    validation: { required: true },
                    //  disabled:true
                  },
                ]
              : []),
            ...(formData.payment_mode !== 1
              ? [
                  {
                    name: "finance_bank",
                    label: "Finance",
                    placeholder: "Enter Finance",
                    type: "dropdown",
                    options: financerVal,
                    required: true,
                    gridClass: "col-lg-4",
                    validation: { required: true },
                    //  disabled:true
                  },
                ]
              : []),
          ]
        : []),
  ];

  const generateSectionFields = (index) =>
    basePaymentFields.map((field) => ({
      ...field,
      name: `${field.name}_${index}`,
    }));

    
  // Add a new section on button click
  const handleAddSection = () => {
    setPaymentSections((prev) => [...prev, generateSectionFields(prev.length)]);
  };

  // Cancel (remove the last added section)
const handleCancelSection = () => {
  setPaymentSections((prev) => prev.slice(0, -1));
};


  useEffect(() => {
    if (formData?.payment_type === 2) {
      setFormData((prevData) => ({
        ...prevData,
        downPayment: totalAmtValue,
      }));
    }
  }, [formData?.payment_type, totalAmtValue]);

  const TABLE_HEADERS = [
    // "Sr No.",
    // "Color ID",
    "Payment Mode",
    "Down Payment",
    "Finance Bank",
    "No. Of Month",
    "Payment Type"
  ];

  const keyMapping = {
    "Payment Type": "payment_type",
    "No. Of Month": "no_of_month",
    "Payment Mode": "payment_mode",
    "Down Payment": "down_payment",
    "Finance Bank": "finance_bank",
  };

//   useEffect(() => {
//     // if(customerIdVal){
//         handleAddPaymentDetails()
//     // }
//   },[])

useEffect(() => {
    if (customerIdVal) {
      handleAddPaymentDetails();
    }
  }, [customerIdVal]);

  const handleAddPaymentDetails = async ( ) => {
    console.log(customerIdVal, "customerIdValues")
    try {
      setLoading(true)
      const response = await axiosInstance.post('/customer-po/edit', {
        customer_id:customerIdVal,
        // po_finance_details:fetchedPaymentDataVal,
        // payment_type: formData?.payment_type,
        // finance_bank: formData?.finance_bank,
        // no_of_month: formData?.no_of_month,
        // payment_mode: formData?.payment_mode,
        // down_payment: formData?.downPayment,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const formattedData = response?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1
      }));

      setPaymentDetailsTable(formattedData);
      console.log("totalpages", totalPages);
    } catch (error) {
      console.error('Error fetching product color list:', error);
    }
    finally {
      setLoading(false)
    }
  };

  const handleAddPaymentForm = async (formData) => {
    console.log(customerIdVal, "customerIdValues")
    try {
      setLoading(true)
      const response = await axiosInstance.post('/customer-po/edit', {
        customer_id: customerIdVal,
        po_finance_details: [
          {
            payment_type: formData?.payment_type,
            down_payment: formData?.downPayment,
            finance_bank: formData?.finance_bank,
            no_of_month: formData?.no_of_month,
            payment_mode: formData?.payment_mode,
          },
        ],
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const formattedData = response?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1
      }));

      if(response.status === 200){
        handleAddPaymentDetails()
      }
    
    } catch (error) {
      console.error('Error fetching product color list:', error);
    }
    finally {
      setLoading(false)
    }
  };


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleAddPaymentDetails(newPage);
  }; 

  const handleEdit = () => {
    console.log("clicked")
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Update Orders</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Update Customer Details
            </span>
            <DynamicForm
              formConfig={DealerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
 <span className="cust-det-title mt-2 mb-2">
              Update Payment Details
            </span>
              <DynamicForm
              formConfig={basePaymentFields}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              />

            <div style={{gap:"1rem"}} className="customer-purchase-order-additional-payment">
              <button
               onClick={() => {
                handleAddPaymentForm(formData);
              }}
                className="customer-purchase-order-additional-payment-button"
              >
                Add
              </button>
               
            </div>
          </div>
          <CustomTable
                            data={paymentDetailsTable}
                            headers={TABLE_HEADERS}
                            keyMapping={keyMapping}
                            itemsPerPage={10}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                            onEdit={handleEdit}
                            totalRecords={totalRecords} />
          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default EditPurchaseOrder;
